/* ============================================================================
   SCENE OUTPUT — Control Panel tab Flow (v3.9) · enjin RESIPI (17 Okt 2026)
   ============================================================================
   Muncul HANYA bila module aktif menuntut enjin `resipi` dengan 3+ scene (App.jsx).
   Dua pilihan (keputusan user 17 Okt):
     'gabung' — gabung semua scene jadi satu video → masuk card
     'asing'  — muat turun setiap scene berasingan → folder Downloads (card tidak memapar video)
   ⛔ RUPA SAHAJA — tiada simpanan di sini. Nilai + simpanan: App.jsx `hasilScene` / `pilihHasilScene`
      (utils/hasilScene.js). Rupa = KEMBAR gaya butang radio WorkflowV39.jsx (supaya dua seksyen sebaris).
   ========================================================================== */
import { useT } from '../i18n';

export default function HasilSceneV39({ nilai = 'gabung', onPilih, bilBabak = 3 }) {
    const t = useT();
    const pilihan = [
        { id: 'gabung', tajuk: t('workspace.sceneOutput.optCombine'), nota: t('workspace.sceneOutput.optCombineDesc', { n: bilBabak }) },
        { id: 'asing', tajuk: t('workspace.sceneOutput.optEach'), nota: t('workspace.sceneOutput.optEachDesc', { n: bilBabak }) },
    ];

    return (
        <div className="s-sect" style={{ padding: '0 0 16px', borderBottom: '1px solid var(--s-line)', marginBottom: 16 }}>
            <p className="s-sect__title">{t('workspace.sceneOutput.title')}</p>
            <div role="radiogroup" aria-label={t('workspace.sceneOutput.title')} style={{ display: 'grid', gap: 6 }}>
                {pilihan.map((p) => {
                    const on = nilai === p.id;
                    return (
                        <button
                            key={p.id}
                            type="button"
                            role="radio"
                            aria-checked={on}
                            onClick={() => onPilih?.(p.id)}
                            style={{
                                display: 'flex', alignItems: 'flex-start', gap: 10,
                                width: '100%', textAlign: 'left', font: 'inherit',
                                padding: '10px 12px', borderRadius: 10, cursor: 'pointer',
                                background: on ? 'var(--s-fill)' : 'transparent',
                                border: `1px solid ${on ? 'var(--s-select)' : 'var(--s-line-strong)'}`,
                                color: 'var(--s-ink)',
                            }}
                        >
                            <span
                                aria-hidden="true"
                                style={{
                                    width: 16, height: 16, borderRadius: '50%', flex: 'none', marginTop: 2,
                                    border: `1.5px solid ${on ? 'var(--s-select)' : 'var(--s-ink-3)'}`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}
                            >
                                {on && <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--s-select)' }} />}
                            </span>
                            <span style={{ minWidth: 0 }}>
                                <span style={{ display: 'block', fontSize: 13, fontWeight: 500, lineHeight: 1.4 }}>{p.tajuk}</span>
                                <span className="s-hint" style={{ display: 'block', margin: '2px 0 0' }}>{p.nota}</span>
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
